(function () {
  'use strict';
  if (!window.jQuery) return;
  document.querySelectorAll('[data-cchw-low-stock]').forEach(function (root) {
    var section = document.getElementById('ProductSection-' + root.dataset.sectionId);
    var message = root.querySelector('[data-low-stock-message]');
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-low-stock-variants]').textContent); } catch (error) { return; }
    if (!section || !message) return;
    window.jQuery(section).off('variantChange.cchwLowStock').on('variantChange.cchwLowStock', function (event) {
      var variant = event.variant && variants.find(function (entry) { return String(entry.id) === String(event.variant.id); });
      message.hidden = !variant || variant.lowStock !== true;
    });
  });
})();
